import { Routes } from '@angular/router';
import { SecureComponent } from './common/layouts/secure/secure.component';
import { SECURE_ROUTES } from './common/layouts/secure/secure.routes';
var ɵ0 = { title: 'Secure Views' };
var APP_ROUTES = [
    { path: '', redirectTo: 'main/results', pathMatch: 'full' },
    // { path: 'home', component: PublicComponent, data: { title: 'Public Views' }, children: PUBLIC_ROUTES },
    { path: 'main', component: SecureComponent, data: ɵ0, children: SECURE_ROUTES },
    // { path: 'guest', component: GuestComponent, pathMatch: 'full' },
    { path: '**', redirectTo: 'main/results' }
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0 };
